import { render, staticRenderFns } from "./ProgramApprovalDelegation.vue?vue&type=template&id=a2631d28"
import script from "./ProgramApprovalDelegation.vue?vue&type=script&lang=ts"
export * from "./ProgramApprovalDelegation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports